/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const AdditionalEquipmentOptions = zod
  .record(zod.string(), zod.boolean())
  .describe(
    "Nonblank unique names and non-null Boolean choices. Incoming duplicate JSON keys must be rejected, never last-wins.",
  );

export type AdditionalEquipmentOptions = zod.input<typeof AdditionalEquipmentOptions>;
export type AdditionalEquipmentOptionsOutput = zod.output<typeof AdditionalEquipmentOptions>;
